// extracted by mini-css-extract-plugin
export default {"backdrop":"styles_backdrop__ewbIu","content":"styles_content__0bcSm","modalCard":"styles_modalCard__Do6uB"};